export function getHtmlTitle(text: string): string | null {
  return text.match(/<title[^>]*>(.*?)<\/title>/i)?.[1] || null;
}
